import React, { Component } from 'react'
import { LIMIT } from '../constants'
import uuid from 'uuid'
import Button from '@material-ui/core/Button'

class Pagination extends Component {
    state = {
        active: 1,
    }
    handleClick = (val, event) => {
        this.props.action(val);
        this.setState({
            active: event
        })
    }

    renderPages() {
        const { count, url } = this.props;
        const limit = LIMIT;
        const maxPage = Math.ceil(count / limit);
        const delta = 2;
        const range = [];
        const rangeWithDots = [];
        let l = '';
        let c = this.state.active
        if (maxPage === 1) {
            return null
        }
        range.push(1)
        for (let i = c - delta; i <= c + delta; i++) {
            if (i < maxPage && i > 1) {
                range.push(i);
            }
        }

        range.push(maxPage);


        for (let i of range) {
            if (l) {
                if (i - l === 2) {
                    rangeWithDots.push(<div className='waves-effect' key={uuid()}><span className="waves-effect">{l + 1}</span></div>);
                } else if (i - l !== 1) {
                    rangeWithDots.push(<div className='waves-effect' key={uuid()}><span className="waves-effect">...</span></div>);
                }
            }
            rangeWithDots.push(<div className={(this.state.active === i) ? 'waves-effect active' : 'waves-effect'} key={uuid()}>
                <Button size="small" color={(this.state.active === i) ? 'primary' : 'default'} onClick={
                    (this.state.active !== i) ?
                        () => this.handleClick(`${url}&limit=${limit}$&offset=${i * limit - limit}`, i) : null
                }>{i}
                </Button></div >);
            l = i;
        }

        return rangeWithDots;
    }

    checkState(value) {
        if (!value) {
            return 'disabled'
        } else {
            return 'waves-effect'
        }

    }

    render() {
        if (this.props.count === 0) {
            return <h2 className='center'>Немає записів</h2>
        }
        return (
            <div style={{ paddingTop: '0.7rem' }}>
                <div style={classes.pagintaion}>
                    {this.renderPages()}
                </div>
            </div>
        )
    }
}

const classes = {
    pagintaion: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
}

export default Pagination


// WEBPACK FOOTER //
// ./src/components/pagination.js